import React from 'react';
import { Box, Divider, Text } from '@chakra-ui/react';

/**
 * @param {{ title: string, children: React.ReactNode, first?: boolean }} props
 */
function ManualeGiocoFormSection({ title, children, first = false }) {
  return (
    <>
      {!first ? <Divider /> : null}
      <Box as="section">
        <Text fontWeight="semibold" fontSize="lg" mb={4}>
          {title}
        </Text>
        {children}
      </Box>
    </>
  );
}

export default ManualeGiocoFormSection;
